import { Outlet, useLocation } from "react-router-dom";

import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

import "./Layout.css";

function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <main className={`page ${isHomePage ? "page--home" : "page--inner"}`}>
      <div className="page__bg" aria-hidden="true" />
      <div className="page__overlay" aria-hidden="true" />

      <Navbar />

      <div className="page__content">
        <Outlet />

        <Footer />
      </div>
    </main>
  );
}

export default Layout;
